/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import {CorsAnywhere} from "../CorsAnywhere";
import React from 'react'

/* global WorldWind */

export default class EcmwfSurfaceO3 extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Surface Ozone (03)",
            service: CorsAnywhere + "http://apps.ecmwf.int/wms/&token=public",
            version: "1.3.0",
            layerNames: "composition_o3_surface",
        };

        super(cfg);

        this.urlBuilder.transparent = false;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "© ECMWF",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>The chemical formula for ozone.</p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                <img
                    src={"https://apps.ecmwf.int/wms/?token=public&request=GetLegend&layers=composition_o3_surface&styles=sh_nipy_spectral_ch4_surface&width=350&height=50"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                ppbv (parts per billion by volume)
            </p>
        </div>);
    }
}
